import { Link } from "react-router-dom";
import "./FeatureCard.scss";

function FeatureCard(feature) {
    return (
        <div className="feature" >
            <Link reloadDocument={true} to={feature?.to}>
                <div className="feature-wrp" >
                    <div className="icon" ><img src={feature?.img} alt='feature-icon' /></div>
                    <div className="content" >
                        <div className="title" >{feature?.title}</div>
                        <div className="desc" >{feature?.content}</div>
                    </div>
                </div>
            </Link>
        </div>
    );
}

export default FeatureCard;